import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { GlobalLoading } from 'react-global-loading';
import { ToastContainer } from "react-toastify";

import LeftSidebar from "./components/Layout/LeftSidebar";
import Footer from "./components/Layout/Footer";
import TopNavbar from "./components/Layout/TopNavbar";
import ScrollToTop from "./components/Layout/ScrollToTop";
import ProtectedRoute from "./components/Auth/ProtectedRoute";

// Authentication
import SignIn from "./pages/auth/SignIn";
import SignUp from "./pages/auth/SignUp";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import ActivationEmail from "./pages/auth/ActivationEmail";
import ResendActivation from "./pages/auth/ResendActivation";
import ConfirmEmail from "./pages/auth/ConfirmEmail";
import LockScreen from "./pages/auth/LockScreen";
import Logout from "./pages/auth/Logout";

// Dashboard
import Dashboard from "./pages/Dashboard";
import PaperFull from "./pages/paper/List";
import PaperCreate from "./pages/paper/Create";

import MyProfile from "./pages/MyProfile";

// // Settings
// import AccountSettings from "./pages/settings/AccountSettings";
// import ChangePassword from "./pages/settings/ChangePassword";
// import Connections from "./pages/settings/Connections";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";

// import Api.js
import * as myApi from "./components/Api";
import {PulseLoader} from "react-spinners";

const App = () => {
  const [active, setActive] = useState(false);
  const [pathname, setPathname] = useState("");
  const [user] = useState(myApi.getUser);
  const [loginPath] = useState(myApi.loginPath);
  const [dashboardPath] = useState(myApi.dashboardPath);

  useEffect(() => {
    setPathname(window.location.pathname); // Get the current path 
  }, []);

  const toggleActive = () => {
    setActive(!active);
  };

  const isAuthPage = [
    "/auth/sign-in/",
    "/auth/sign-up/",
    "/auth/forgot-password/",
    "/auth/reset-password/",
    "/auth/activation/",
    "/auth/confirm-email/",
    "/auth/lock-screen/",
    "/auth/logout/",
    "/not-found/",
    "/features/",
    "/team/",
    "/faq/",
    "/contact/",
    "/privacy-policy/",
    "/term-conditions/",
  ].includes(pathname);

  const isAuthenticated = myApi.checkUserActive();

  return (
    <>
      <div className={`main-wrapper-content ${active ? "active" : ""}`}>
        <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
            />

        <Router>
          {!isAuthPage && (
            <>
              <LeftSidebar user={user} toggleActive={toggleActive} />
            </>
          )}
          
          <div className={!isAuthPage ? 'main-content d-flex flex-column' : 'mt-5 pt-5 d-flex flex-column'}>
            <ScrollToTop />

            {!isAuthPage && (
              <>
                <TopNavbar user={user} toggleActive={toggleActive} />
              </>
            )}

            <Routes>
              {/* Authentication */}
              <Route path="/auth/sign-in/" element={<SignIn />} />
              <Route path="/auth/sign-up/" element={<SignUp />} />
              <Route path="/auth/forgot-password/" element={<ForgotPassword />} />
              <Route path="/auth/reset-password/" element={<ResetPassword />} />
              <Route path="/auth/activation/" element={<ActivationEmail />} />
              <Route path="/auth/resend-activation/" element={<ResendActivation />} />
              <Route path="/auth/confirm-email/" element={<ConfirmEmail />} />
              <Route path="/auth/lock-screen/" element={<LockScreen />} />
              <Route path="/auth/sign-out/" element={<Logout />} />

              <Route path="/privacy-policy/" element={<PrivacyPolicy />} />
              <Route path="/term-conditions/" element={<TermsConditions />} />

              {/* Protected routes */}
              <Route path="/dashboard/" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/paper/list/" element={
                <ProtectedRoute>
                  <PaperFull />
                </ProtectedRoute>
              } />
              <Route path="/paper/add/" element={
                <ProtectedRoute>
                  <PaperCreate />
                </ProtectedRoute>
              } />
              <Route path="/paper/edit/" element={
                <ProtectedRoute>
                  <PaperCreate />
                </ProtectedRoute>
              } />
              <Route path="/profile/" element={
                <ProtectedRoute>
                  <MyProfile />
                </ProtectedRoute>
              } />
            </Routes>

            {!isAuthenticated && !isAuthPage && (
            <>
              <Navigate to={loginPath} replace/>
            </>
            )}

            {isAuthenticated && pathname === loginPath && (
              <>
                <Navigate to={myApi.getUser()?.role === 'admin' ? dashboardPath : '/paper/list/'} replace />
              </>
            )}
            <Footer />
          </div>
        </Router>
        <GlobalLoading zIndex={9999}>
          <PulseLoader color={"white"} size={30} />
        </GlobalLoading>
      </div>
      
    </>
  );
};

export default App;
